import { z } from "zod";

export const FileSourceSchema = z.enum(["swivu", "companycam"]);
export type FileSource = z.infer<typeof FileSourceSchema>;

export const FileSchema = z.object({
  id: z.int().positive().readonly(),
  url: z.url().nullable().readonly(),
  thumbnail_url: z.url().nullable().readonly(),
  name: z.string().nullable().readonly(),
  task: z.int().nullable(),
  resource: z.int().nullable(),
  client: z.int().nullable(),
  order: z.number().min(0).max(2147483647),
  description: z.string().max(255).nullable(),
  created_at: z.iso.datetime().readonly(),
  updated_at: z.iso.datetime().readonly(),
  creator: z.string().nullable(),
  size_bytes: z.int().nonnegative().readonly(),
  has_permission: z.boolean().nullish(),
  can_analyze: z.boolean().optional(),
  // Public agenda serializers do not expose provenance yet.
  source: FileSourceSchema.optional(),
  external_id: z.string().nullable().optional()
});
